module.exports = __webpack_public_path__ + "static/media/29BDOS8.73a51736.jpg";